import {dispatch} from '../dispatcher';
import common from './common';

const SearchActions = {
  
  searchUpcoming: function(searchTerm) {
    common.promiseXHR('GET', 'v2/items/searchUpcoming/' + searchTerm)
      .then(result => {
        dispatch({
          type: 'items/search',
          search: result.data.Results
        });
      });
  }
  
};

export default SearchActions;